// client/admin-client/src/components/notice/noticeStorage.js
// client/admin-client/src/components/notice/noticeStorage.js
 export function makeId() {
   return `n_${Date.now()}_${Math.random().toString(16).slice(2)}`;
 }
 
 export function makeEmptyNotice({ writer = 'admin' } = {}) {
   return {
     id: makeId(),
     title: '',
     content: '',
     writer,
     language: 'EN',
     isPinned: false,
     isPublished: true,
     publishedAt: null,
     createdAt: null,
     updatedAt: null,
   };
 }
 
 function asBool(value, fallback = false) {
   if (typeof value === 'boolean') return value;
   if (typeof value === 'number') return value === 1;
   if (typeof value === 'string') {
     const v = value.trim().toLowerCase();
     if (['1', 'true', 'y', 'yes'].includes(v)) return true;
     if (['0', 'false', 'n', 'no'].includes(v)) return false;
   }
   return fallback;
 }
 
 export function normalizeNotice(raw = {}) {
   const id =
     raw.id ??
     raw.noticeId ??
     raw.notice_id ??
     makeId();
 
   return {
     id: String(id),
     title: String(raw.title || ''),
     content: String(raw.content || ''),
     writer: String(raw.writer || 'admin'),
     language: String(raw.language || 'EN').toUpperCase(),
     isPinned: asBool(raw.isPinned ?? raw.is_pinned, false),
     isPublished: asBool(raw.isPublished ?? raw.is_published, true),
     publishedAt: raw.publishedAt || raw.published_at || null,
     createdAt: raw.createdAt || raw.created_at || null,
     updatedAt: raw.updatedAt || raw.updated_at || null,
   };
 }
 
 export function sortNoticeItems(list = []) {
   return [...list]
     .map(normalizeNotice)
     .sort((a, b) => {
       if (!!a.isPinned !== !!b.isPinned) return a.isPinned ? -1 : 1;
       return new Date(b.updatedAt || b.createdAt || 0) - new Date(a.updatedAt || a.createdAt || 0);
    });
}